import { render, staticRenderFns } from "./metadata-subtitles.vue?vue&type=template&id=0912d7d6&scoped=true&"
import script from "./metadata-subtitles.vue?vue&type=script&lang=js&"
export * from "./metadata-subtitles.vue?vue&type=script&lang=js&"
import style1 from "./metadata-subtitles.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0912d7d6",
  null
  
)

export default component.exports